import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Environment } from '../../core/env/environment';
import { getDefaultBrandId } from '../../core/env/brand';

export const useLayoutStyles = makeStyles<Theme, { environment?: Environment }>((theme) => ({
  root: {
    paddingTop: '80px',
    [theme.breakpoints.down('sm')]: {
      paddingTop: '60px'
    },
    backgroundSize: '100% 350px',
    minHeight: '100%',
    backgroundPosition: 'top',
    paddingBottom: '2rem',
    background: ({ environment }) =>
      `url('/media/brands/${environment?.brandId ?? getDefaultBrandId()}/background.png') no-repeat top / 100% 350px`
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
    paddingBottom: '50px'
  },
  drawerRoot: {
    display: 'flex'
  }
}));
